import baseUrl from "../energyApiHost";
import { callApi } from "./util";

const createAlertComment = (alertId, content) => {
  const url = `${baseUrl}alert-comments`;

  const headers = {
    "Content-Type": "application/json"
  };

  const config = {
    headers,
    method: "POST",
    body: JSON.stringify({
      alertId: alertId,
      content: content
    })
  };

  return callApi(url, config);
};

export default {
  createAlertComment
};
